module.exports = __webpack_public_path__ + "static/media/data-vis-poster.cbe9c171.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/posterImgs/data-vis-poster.jpg
// module id = 417
// module chunks = 0